import { useLenis } from "lenis/react";

const Footer = () => {
  const lenis = useLenis();

  const scrollToSection = (href) => {
    if (href.length > 1 && href.startsWith("#")) {
      const element = document.querySelector(href);
      if (!element) return;
      if (lenis) {
        lenis.scrollTo(element, { offset: -80, duration: 1.4 });
      } else {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const footerLinks = [
    { label: "Product", href: "#what-tenacity-does" },
    { label: "Enterprise Context", href: "#pillars" },
    { label: "Security", href: "#security" },
  ];

  return (
    <footer 
      className="py-16 md:py-24 px-6 md:px-12 lg:px-24 border-t border-white/10"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* Logo & Description */}
          <div className="max-w-sm">
            <a href="/" className="flex items-center gap-2 mb-4" data-testid="footer-logo">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#00E5FF] to-[#06B6D4] flex items-center justify-center">
                <span className="text-[#050505] font-bold text-lg font-['Outfit']">T</span>
              </div>
              <span className="text-xl font-bold tracking-tight text-white font-['Outfit']">
                OnTenacity
              </span>
            </a>
            <p className="text-sm text-[#71717A] leading-relaxed">
              AI-powered executive intelligence for leadership teams.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-6 md:gap-8">
            {footerLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="text-sm text-[#A1A1AA] hover:text-white transition-colors"
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex gap-4">
            <button 
              onClick={() => scrollToSection("#")}
              className="text-sm text-[#00E5FF] hover:text-[#33EBFF] transition-colors"
              data-testid="footer-diagnostic-link"
            >
              Start Diagnostic
            </button>
            <button 
              onClick={() => scrollToSection("#")}
              className="text-sm text-[#A1A1AA] hover:text-white transition-colors"
              data-testid="footer-demo-link"
            >
              Request Demo
            </button>
          </div>
        </div>

        {/* Divider */}
        <div className="section-divider my-12" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <p className="text-xs text-[#52525B]">
            © {new Date().getFullYear()} OnTenacity. All rights reserved.
          </p>
          <a
            href="/privacy"
            className="text-xs text-[#52525B] hover:text-[#00E5FF] transition-colors"
            data-testid="footer-privacy-link"
          >
            Privacy Policy
          </a>
          <p className="text-xs text-[#52525B]">
            AI-powered executive intelligence platform.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
